import * as React from 'react'

import { Form } from 'factorial-form'
import { ContractFlowCustomFieldFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import { getCustomFieldKey } from 'modules/contracts/lib/customFields'

interface Props {
  form: Form
  field: ContractFlowCustomFieldFragment
}

const SingleChoiceCustomField = ({ form, field }: Props) => {
  const fieldOptions = field.options?.filter((option) => option.isActive).filter(Boolean) ?? []
  const options = fieldOptions.map((option) => ({
    label: option.label ?? '',
    value: option.value ?? '',
  }))

  return (
    <Select
      mandatory={field.required ?? false}
      label={field.labelText}
      field={form.get(getCustomFieldKey(field))}
      none={i18n.t('settings.custom_fields.new.labels.choose')}
      options={options}
    />
  )
}

export default observer(SingleChoiceCustomField)
